const guideSteps = [
  {
    title: 'Invoices & Disputes',
    label:
      'Learn how to review invoices, open invoice details, and manage disputes from the Invoice section.',
    videoURL: 'https://youtu.be/b8wynVITmKI',
  },
  {
    title: 'Navigation Menu Overview',
    label:
      'A walkthrough of the redesigned main menu, including Property, Users, Add Users, and secondary links.',
    videoURL: 'https://youtu.be/WcfgAQTOG4E',
  },
  {
    title: 'Dashboard Overview',
    label:
      'See how dashboard KPI cards and charts summarize portfolio performance across your delegations.',
    videoURL: 'https://youtu.be/bz0i8A32qlw',
  },
  {
    title: 'Inviting a Supporting User',
    label:
      'Step-by-step instructions for inviting Full Portfolio, Multi-Site, or Property Manager users.',
    videoURL: 'https://youtu.be/-TcS33LLHtQ',
  },
  {
    title: 'Move User',
    label: 'Learn how to update user delegations and move users within the hierarchy tree.',
    videoURL: 'https://youtu.be/WLP3mkRFviY',
  },
  {
    title: 'File a Claim',
    label: 'How to file an insurance claim from an issued policy in the Property section.',
    videoURL: 'https://youtu.be/W-lBi1zSQGo',
  },
  {
    title: 'Report a Bug or Issue',
    label: 'How to report portal feedback or technical issues using the Report an issue link.',
    videoURL: 'https://youtu.be/EYGM_8ZMf0M',
  },
];

const guideTitles = [
  { title: 'Welcome', key: 'welcome' },
  { title: 'Users', key: 'users' },
  { title: 'Pages', key: 'pages' },
  { title: 'Videos', key: 'videos' },
];

export default {
  guideTitles,
  guideSteps,
};
